import { render, staticRenderFns } from "./ContractOfficeSettings.vue?vue&type=template&id=61a6c0ce"
import script from "./ContractOfficeSettings.vue?vue&type=script&lang=js"
export * from "./ContractOfficeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports